<div class="add-70">
    <div class="small-banner">
        <div class="container align-items-center flex-wrap h-100" style="display: grid;">
            <h2 class="font-600 text-center">
                Security
            </h2>
        </div>
    </div>
</div>

<div class="page-section">
    <div class="container">
        <div class="row">
            <div class="col">
                <h3 class="font-600">
                    How Does NuvertOS Safeguard Your Data?
                </h3>
                <p>To ensure your data is secure, we look above and beyond the industry standards.</p>
                <p>We adhere to recognized security patterns for encryption, hardening, authentication, and authorization. Our security team periodically reviews and improves our security posture. Additionally, data can be shared in the format needed with third parties or other systems without sacrificing security or privacy.</p>
                <p>All web application communications are encrypted over 256-bit SSL, which cannot be viewed by a third party and is the same level of encryption used by banks and financial institutions.</p>
            </div>
        </div>

        <div class="row align-items-center flex-wrap h-100 usp-row">
            <div class="col-6">
                <h3 class="font-600">Data Centers</h3>
                <p>Data centers are located in India to provide low latency and fulfil Indian government protocols for medical data storage</p>
            </div>
            <div class="col-6 float-right">
                <img src="assets/img/data_centers.svg" alt="Data Centers" class="usp-image">
            </div>
        </div>
        <div class="row align-items-center flex-wrap h-100 usp-row">
            <div class="col-6">
                <img src="assets/img/encryption.svg" alt="encryption" class="usp-image" style="transform: scaleX(-1);">
            </div>
            <div class="col-6 text-right">
                <h3 class="font-600">Encryption</h3>
                <p>All web application communications are encrypted over 256 bit SSL, which cannot be viewed by a third party and is the same level of encryption used by banks and financial institutions</p>
            </div>
        </div>
        <div class="row align-items-center flex-wrap h-100 usp-row">
            <div class="col-6">
                <h3 class="font-600">AWS Hosting</h3>
                <p>NuvertOS is hosted entirely on Amazon Web Services (AWS), providing end-to-end security and privacy features built in. In order to ensure a secure infrastructure environment, we have made additional efforts. For more details regarding AWS security, please refer to <a href="https://aws.amazon.com/security/" target="_blank">this article.</a></p>
            </div>
            <div class="col-6">
                <img src="assets/img/aws_logo.svg" alt="AWS Logo" class="usp-image float-right" width="350rem">
            </div>
        </div>

        <div class="row">
            <div class="col-12 text-center">
                <h3 class="font-600">
                    Technical Parameters
                </h3>
            </div>
            <div class="col">
                <img src="assets/img/technical-parameters.svg" alt="" srcset="">
            </div>
        </div>
    </div>
</div>

<app-contact-card></app-contact-card>
